import { faFileUpload } from "@fortawesome/pro-regular-svg-icons/faFileUpload";
import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faExternalLinkSquare } from "@fortawesome/pro-solid-svg-icons/faExternalLinkSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, Grid, ListItem, Typography } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import AppResource from "components/Translations/AppResources";
import PublicationTypeName from "components/Translations/PublicationTypeName";
import UserFullProfileLink from "components/UserFullProfileLink";
import { Formaters } from "lib/Formarters";
import HtmlUtils from "lib/HtmlUtils";
import MediaUtils from "lib/MediaUtils";
import { FileGetDto, GlobalSearchItem } from "models/ApiModels";
import * as React from "react";
import { styles } from "views/Publication/Components/FileOrMetadataStyles";
import { getPublicationSecondViewAction } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: GlobalSearchItem;
    index: number;
    querySearch?: string;
    showDivider: boolean;
}

type Props = IProps & WithStyles<typeof styles>;

/////////////////////////////////////////////////////////////////////////////////////////////////

const SearchRenderDocumentComponent: React.FC<Props> = (props) => {

    const { data, index, classes, showDivider } = props;

    const file = data.additionalInfo as FileGetDto;
    const metadata = file.metadata;
    const isOffice = MediaUtils.isOfficeDocument(metadata.fileExtension) && !HtmlUtils.isLocalhost();
    const isPdf = MediaUtils.isPDF(metadata.fileExtension);

    const url = isOffice
        ? MediaUtils.makeOfficeViewerUrl(file.url)
        : file.url;

    let divRef: HTMLElement = null;

    return (
        <React.Fragment key={"seachItem-" + index}>
            <ListItem
                button
                onClick={(e) => HtmlUtils.openUrlInNewWindow(url, data.id)}
            >
                <GridEx container wrap="nowrap" spacing={1}>
                    <GridEx item>
                        <img src={MediaUtils.getImageFromMimeType(file.mimeType, metadata.fileExtension)} alt={metadata.fileExtension} width={64} height={64} />
                    </GridEx>
                    <GridEx item xs>
                        <div>
                            <Typography color="secondary" variant="body1">
                                <MuiLink id="openDoc"
                                    rel="noopener noreferrer"
                                    onClick={
                                        () => getPublicationSecondViewAction(data.publicationType, data.id, data.parentId, props.querySearch, data.title)()
                                    }
                                >
                                    <span className={classes.title}>
                                        {data.title}
                                    </span>
                                </MuiLink>
                            </Typography>
                        </div>
                        <div ref={(ref) => divRef = ref}>
                            <Grid container spacing={1} justifyContent="center" alignItems="center">
                                <Grid item xs className={classes.columnMiddle}>
                                    {metadata.title != null && metadata.title != "" ? metadata.title : metadata.filename}
                                </Grid>
                                <Grid item>
                                    <FontAwesomeIcon icon={isOffice || isPdf ? faExternalLinkSquare : faDownload} size="1x" />
                                </Grid>
                            </Grid>
                        </div>

                        <MuiMuted>
                            <Typography variant="caption">
                                <b><PublicationTypeName publicationType={data.publicationType} /></b>

                                <span>&nbsp;<AppResource resource="Common.Literals.WrittenBy" parameters="lowercase" /> <UserFullProfileLink user={{ userId: data.authorId, name: data.authorName }} /></span>

                                <span>&nbsp;&mdash;&nbsp;<FontAwesomeIcon icon={faFileUpload} fixedWidth /> {Formaters.relativeTime(data.lastUpdateDate)}</span>

                                {
                                    !isOffice &&
                                    <span>&nbsp;&mdash;&nbsp;{Formaters.fileSize(metadata.fileSize)}</span>
                                }
                            </Typography>
                        </MuiMuted>
                    </GridEx>
                </GridEx>
            </ListItem>
            {showDivider && <Divider />}
        </React.Fragment>
    );
};

export const SearchRenderDocument = withStyles(styles)(SearchRenderDocumentComponent);